module.exports = __webpack_public_path__ + "static/img/monkey_null.42381c0.png";


//////////////////
// WEBPACK FOOTER
// ./common/assets/img/monkey_null.png
// module id = XYki
// module chunks = 1